import type { LucideIcon } from 'lucide-react'
import { PackageOpenIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface AgenciesEmptyStateProps {
  title: string
  description: string
  icon?: LucideIcon
  actionLabel?: string
  onAction?: () => void
  className?: string
}

export const AgenciesEmptyState = ({
  title,
  description,
  icon: Icon = PackageOpenIcon,
  actionLabel,
  onAction,
  className,
}: AgenciesEmptyStateProps): ReactNode => (
  <div
    className={cn(
      'agencies-empty-state flex flex-col items-center justify-center py-16 px-4 text-center',
      className
    )}
  >
    <div className="agencies-empty-state-icon mb-4 rounded-full bg-muted p-4">
      <Icon className="size-8 text-muted-foreground" />
    </div>
    <h3 className="agencies-empty-state-title text-lg font-semibold mb-2">{title}</h3>
    <p className="agencies-empty-state-description text-sm text-muted-foreground max-w-md mb-6">
      {description}
    </p>
    {actionLabel && onAction && (
      <Button className="agencies-empty-state-action" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </div>
)
